// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './more_articles.module.less';
import cn from 'classnames';
import etask from 'zetask';
import {Article_card} from './article_card';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_data_provider} from '../../../../hola/pub/lib/use_data_provider';
import {get_data_id} from '../../pages/oculus.toolip.io/blog';

interface i_article_card_data {
    url: string;
    category?: string | string[];
    title?: string;
    description?: string;
    img?: string;
    author?: string;
    min_read?: number;
}

interface i_more_articles_props {
    title?: string;
    exclude_url?: string;
    amount?: number;
}

export const fetch_articles_for_cards = ()=>{
    return etask(function*(){
        try {
            const domain = 'https://oculusproxies.com';
            const url = `${domain}/cms/get_matched_list?path=/empty/blog&`+
                `include_cmp=Article_widget&`+
                `cmp_props=category,title,img,author,min_read,description`;
            const list_response = yield fetch(url);
            const list_data = yield list_response;
            if (list_data.status !== 'ok' || !list_data.list)
                return [];
            let all_paths = Object.keys(list_data.list);
            all_paths.sort((a, b)=>b.localeCompare(a));
            const articles = [];
            for (const path of all_paths)
            {
                try {
                    const path_data = list_data.list[path];
                    if (path_data && path_data.overrides?.root?.length)
                    {
                        const widget = path_data.overrides.root[0];
                        if (widget && widget.props)
                        {
                            articles.push({
                                url: path_data.meta?.url || path,
                                category: widget.props.category,
                                title: widget.props.title,
                                description: widget.props.description,
                                img: widget.props.img,
                                author: widget.props.author,
                                min_read: widget.props.min_read
                            });
                        }
                    }
                } catch(e){
                    console.error(`Error processing article for ${path}`);
                }
            }
            return articles;
        } catch(e){
            return [];
        }
    });
};

export const More_articles = (props: i_more_articles_props)=>{
    const {theme} = useContext(Settings_context);
    const {data} = use_data_provider(get_data_id);
    const [articles, set_articles] = useState<i_article_card_data[]>([]);
    useEffect(()=>{
        if (data?.status == 'done' && data?.result?.data?.posts)
        {
            let filtered_articles = data.result.data.posts;
            if (props.exclude_url)
            {
                filtered_articles = filtered_articles.filter(article=>
                    article.url !== props.exclude_url);
            }
            if (props.amount && filtered_articles.length > props.amount)
                filtered_articles = filtered_articles.slice(0, props.amount);
            set_articles(filtered_articles);
        }
    }, [data, props.amount, props.exclude_url]);
    if (!articles.length)
        return null;
    return <div className={cn(
      styles.more_articles_container)}>
      <h3 className={cn(theme.H3, styles.section_title)}>
        {props.title || 'Related Articles'}
      </h3>
      <div className={styles.articles_column}>
        {articles.map((article, index)=>
            <Article_card
              key={index}
              url={article.url}
              category={article.category}
              title={article.title}
              description={article.description}
              img={article.img}
              author={article.author}
              min_read={article.min_read}
            />
          )}
      </div>
    </div>;
};
